export const Notifications = {
  1: { // TYPE_CUSTOMER_NEW_RESERVATION: {
    name: 'Customer New Reservation',
    information: 'Sent when a customer makes a new online reservation via your minisite, booking widgets or Facebook.'
  },
  11: { // TYPE_CUSTOMER_MOVE_RESERVATION: {
    name: 'Customer Move Reservation',
    information: 'Sent when a customer moves their reservation via your minisite.'
  },
  2: { // TYPE_CUSTOMER_CANCEL_RESERVATION: {
    name: 'Customer Cancel Reservation',
    information: 'Sent when a customer cancels reservation via your minisite.'
  },
  3: { // TYPE_CUSTOMER_CHECKIN: {
    name: 'Customer Check-in',
    information: 'Sent when a customer checks in to an appointment.'
  },
  4: { // TYPE_CUSTOMER_ONLINE_PAYMENT: {
    name: 'Customer Payment',
    information: 'Sent when a customer makes a payment (reservation deposit, gift card, pass, etc) via your minisite, booking widgets or Facebook.'
  },
  20: { // TYPE_CUSTOMER_CONFIRM_RESERVATION: {
    name: 'Customer Reservation Confirmation',
    information: 'Sent when a customer confirms that they will be attending the appointment via an email or SMS reply.'
  },
  21: { // TYPE_CUSTOMER_FORM_RECEIVED: {
    name: 'Customer Form Received',
    information: 'Sent when a customer fills in a form via your minisite.'
  },
  23: { // TYPE_CUSTOMER_EMAIL_BOUNCE: {
    name: 'Customer Email Bounced',
    information: 'Sent when an email is bounced for a customer.'
  },
  12: { // TYPE_INTERNAL_NEW_RESERVATION: {
    name: 'Internal New Reservation',
    information: 'Sent when a new reservation is made internally via our iOS, Android or web apps.'
  },
  13: { // TYPE_INTERNAL_MOVE_RESERVATION: {
    name: 'Internal Move Reservation',
    information: 'Sent when a reservation is moved internally via our iOS, Android or web apps.'
  },
  14: { // TYPE_INTERNAL_CANCEL_RESERVATION: {
    name: 'Internal Cancel Reservation',
    information: 'Sent when a reservation is cancelled internally via our iOS, Android or web apps.'
  },
  15: { // TYPE_INTERNAL_CHECKIN: {
    name: 'Internal Check-in',
    information: 'Sent when a customer is checked in to an appointment internally via our iOS, Android or web apps.'
  },
  22: { // TYPE_INTERNAL_NOSHOW: {
    name: 'Internal No-show',
    information: 'Sent when a customer is marked as a no-show for an appointment internally via our iOS, Android or web apps.'
  },
  7: { // TYPE_SUBSCRIPTION_PAYMENT_SUCCESS: {
    name: 'Payment Success',
    information: 'Sent when your monthly subscription payment has been received.'
  },
  8: { // TYPE_SUBSCRIPTION_PAYMENT_FAILED: {
    name: 'Payment Failure',
    information: 'Sent if there is a failure with your monthly subscription payment.'
  },
  18: { // TYPE_SUBSCRIPTION_PAYMENT_EXPIRING: {
    name: 'Payment method expiring',
    information: 'Sent if your payment method will be expiring soon.'
  },
  16: { // TYPE_SUBSCRIPTION_ACCOUNT_ACTIVATED: {
    name: 'Account Activated',
    information: 'Sent when your account subscription is activated.'
  },
  47: { // TYPE_SUBSCRIPTION_ACCOUNT_REACTIVATED: {
    name: 'Account Re-activated',
    information: 'Sent when your account subscription is re-activated.'
  },
  9: { // TYPE_SUBSCRIPTION_ACCOUNT_SUSPENDED: {
    name: 'Account Suspension',
    information: 'Sent if there have been multiple payment failures and your monthly subscription has been suspended.'
  },
  17: { // TYPE_SUBSCRIPTION_ACCOUNT_CANCELLED: {
    name: 'Account Cancellation',
    information: 'Sent when your account is cancelled.'
  },
  10: { // TYPE_REVIEW_RECEIVED: {
    name: 'Review Received',
    information: 'Sent when a customer leaves a review after their reservation.'
  },
  19: { // TYPE_SMS_REPLY_RECEIVED: {
    name: 'SMS Reply Received',
    information: 'Sent when a customer replies to an SMS from our system numbers.'
  },
  24: { // TYPE_MESSAGE_RECEIVED: {
    name: 'Message Received',
    information: 'Sent when a customer replies to a message sent from our system.'
  },
  25: { // TYPE_LOGIN_FROM_LINK: {
    name: 'Email Login Link Used',
    information: 'Sent when someone logs into your account using an email link.'
  },
  26: { // TYPE_WAITLIST_AVAILABLE: {
    name: 'Waitlisted request available',
    information: 'Sent when a request on the waitlist becomes available.'
  },
  27: { // TYPE_WAITLIST_CUSTOMER_ADD: {
    name: 'Customer request waitlisted',
    information: 'Sent when a customer request has been added to the waiting list.'
  },
  28: { // TYPE_REFERRAL_STARTED_TRIAL: {
    name: 'Referred Trial Started',
    information: 'Sent when a referred business begins their trial.'
  },
  29: { // TYPE_REFERRAL_SIGNED_UP: {
    name: 'Referred Sign-up',
    information: 'Sent when a referred business signs up.'
  },
  30: { // TYPE_REFERRAL_PAID_OUT: {
    name: 'Referral Payment made',
    information: 'Sent when a referral payment is made.'
  },
  31: { // TYPE_EMAIL_VERIFICATION_COMPLETE: {
    name: 'Email Verification Complete',
    information: 'Sent when the email is verified.'
  },
  32: { // TYPE_EMAIL_VERIFICATION_MANUAL_REQUIRED: {
    name: 'Manual Email Verification Required',
    information: 'Sent when manual email verification is required.'
  },
  6: { // TYPE_SMS_LOW: {
    name: 'SMS Credits Low',
    information: 'Sent when your SMS credits reach low levels and you may need to purchase additional credits to continue SMS service.'
  },
  33: { // TYPE_SMS_PLAN_LOW_50: {
    name: 'SMS Plan Credits Low - 50%',
    information: 'Sent when your included monthly SMS credits reach 50%. You may need to purchase additional credits to continue SMS service.'
  },
  34: { // TYPE_SMS_PLAN_LOW_75: {
    name: 'SMS Plan Credits Low - 75%',
    information: 'Sent when your included monthly SMS credits reach 75%. You may need to purchase additional credits to continue SMS service.'
  },
  35: { // TYPE_SMS_PLAN_SUSPENDED: {
    name: 'SMS Plan Credits expired',
    information: 'Sent when your included monthly SMS credits are required. You will need to purchase additional credits to continue SMS service.'
  },
  36: { // TYPE_SMS_USING_EXTRA: {
    name: 'SMS Plan Credits expired, using Extra SMS Credit',
    information: 'Sent when your included monthly SMS credits are required and the system will begin using your purchased Extra SMS credit.'
  },
  37: { // TYPE_SMS_EXTRA_LOW: {
    name: 'Purchased SMS Messages Low',
    information: 'Sent when your purchased SMS messages are low. You may need to purchase additional messages to continue SMS service.'
  },
  100: { // TYPE_SMS_EXTRA_LOW_100: {
    name: 'SMS Extra Credits Low',
    information: 'Sent when your purchased extra SMS credits are low. You may need to purchase additional credits to continue SMS service.'
  },
  38: { // TYPE_SMS_EXTRA_LOW_50: {
    name: 'Extra SMS Credits Very Low',
    information: 'Sent when your purchased extra SMS credits are very low. You may need to purchase additional credits to continue SMS service.'
  },
  39: { // TYPE_SMS_EXTRA_SUSPENDED: {
    name: 'Extra SMS Credits expired',
    information: 'Sent when your purchased extra SMS credits have been used. You will need to purchase additional credits to continue SMS service.'
  },
  40: { // TYPE_SMS_AUTO_TOPUP_PURCHASED: {
    name: 'Auto-Topup Purchased Extra SMS Credits',
    information: 'Sent when the SMS credit auto-topup system successfully purchases extra SMS credits.'
  },
  41: { // TYPE_SMS_AUTO_TOPUP_FAILED: {
    name: 'SMS Auto-Topup Purchase Failed',
    information: 'Sent when the SMS credit auto-topup system encounters a failue when attempting to purchases extra SMS credits.'
  },
  42: { // TYPE_SUBSTITUTION_REQUEST: {
    name: 'Reservation Substitution Request',
    information: 'Sent when a substitution is requested for a reservation.'
  },
  43: { // TYPE_SUBSTITUTION_REQUEST_DECLINED: {
    name: 'Reservation Substitution Request Declined',
    information: 'Sent when a substitution is declined.'
  },
  44: { // TYPE_SUBSTITUTION_REQUEST_ACCEPTED: {
    name: 'Reservation Substitution Request Accepted',
    information: 'Sent when a substitution is accepted.'
  },
  45: { // TYPE_SUBSTITUTION_REQUEST_CONFIRMED: {
    name: 'Reservation Substitution Request Confirmed',
    information: 'Sent when a substitution is confirmed.'
  },
  46: { // TYPE_ACCOUNT_VERIFICATION_PIN: {
    name: 'Account Verification PIN',
    information: 'Sent to verify a customer account.'
  },
  48: { // TYPE_INTEGRATION_REAUTHENTICATE: {
    name: 'App integration requires re-connecting',
    information: 'Sent when an app integration requires you to re-connect.'
  },
  49: { // TYPE_EXPORT_COMPLETE: {
    name: 'Export complete',
    information: 'Sent when an export report is available to download.'
  },
  50: { // TYPE_WAITLIST_CUSTOMER_CANCEL: {
    name: 'Waitlist request cancelled',
    information: 'Sent when a customer request for a waiting list is cancelled.'
  },
  53: { // TYPE_CUSTOM_DOMAIN_ACTIVE: {
    name: 'Custom domain became active',
    information: 'Sent when your custom domain is connected and becomes active.'
  },
  54: { // TYPE_CUSTOM_DOMAIN_INACTIVE: {
    name: 'Custom domain became inactive',
    information: 'Sent when your custom domain becomes inactive or is disconnected.'
  },
  55: { // TYPE_MARKETING_CAMPAIGN_PROMPT: {
    name: 'Marketing Campaign Prompt',
    information: 'Sent when a marketing campaign prompt is available for your business.'
  },
  57: { // TYPE_CUSTOMER_MESSAGE_RECEIVED: {
    name: 'Customer message received',
    information: 'Sent when a customer sends you a message.'
  },
  58: { // TYPE_CUSTOMER_NEW_COURSE: {
    name: 'Customer New Course',
    information: 'Sent when a customer enrolls in a new course.'
  }
}
